/**
 * Shared export helpers for one-click CSV and PDF output on list screens.
 * CSV is generated client-side; PDF reuses the browser print dialog, which
 * already hides the app chrome through the [data-print-hide] print styles.
 */

/** Escape a single CSV cell so commas, quotes and newlines stay intact. */
function csvCell(value: string | number): string {
  const text = String(value ?? '');
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Build a CSV document from a header row and data rows. */
export function buildCsv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((row) => row.map(csvCell).join(',')).join('\r\n');
}

/** Trigger a browser download for a generated CSV payload. */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/** A date stamp (yyyy-mm-dd) for export file names. */
export function exportStamp(): string {
  return new Date().toISOString().slice(0, 10);
}